import "./TestPromoCards.css";
import card1Img from "../../../assets/girl-sitting-with-laptop.jpg";
const ArrowIcon = () => <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>;

const cards = [
  { featured: true, label: "Flagship Degree", title: "MA in Global Business & Strategic Leadership", text: "Our flagship Master's degree for aspiring and experienced leaders seeking advanced training in strategy, leadership and global business.", support: "Inaugural intake: March 2027", cta: "View Programme", href: "/masters/leadership", image: card1Img, fallback: "linear-gradient(135deg, #0C1F3F, #142d54, #C5A44E)" },
  { label: "Professional Certificates", title: "Certified Professional Programmes", text: "Career-focused postgraduate and professional certificates for working professionals, consultants, coaches and project leaders.", support: "Executive Coach, Business Consultant, Project Mgmt", cta: "Explore Certificates", href: "/certified", image: "https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=700&h=500&fit=crop&q=80", fallback: "linear-gradient(135deg, #142d54, #1a3a6b, #C5A44E)" },
  { label: "Admissions", title: "Admissions & How to Apply", text: "Find entry requirements, application guidance, and the next steps for joining ESBD as a local or international student.", support: "Application guidance and admissions support", cta: "Start Your Application", href: "/admissions", image: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=700&h=500&fit=crop&q=80", fallback: "linear-gradient(135deg, #0C1F3F, #1a3a6b, #D4B96A)" },
];

export default function TestPromoCards() {
  return (
    <div className="th-promo">
      <div className="th-promo__grid">
        {cards.map((c, i) => (
          <a key={i} href={c.href} className={`th-promo__card ${c.featured ? "th-promo__card--feat" : ""}`}>
            <div className="th-pc-img" style={{ background: c.fallback }}>
              <img src={c.image} alt={c.title} loading="lazy" onError={(e) => { e.target.style.display = "none"; }} />
              <span className="th-pc-badge">{c.label}</span>
            </div>
            <div className="th-pc-body">
              <h3 className="th-pc-title">{c.title}</h3>
              <p className="th-pc-text">{c.text}</p>
              <div className="th-pc-support">{c.support}</div>
              <span className="th-pc-cta">{c.cta} <ArrowIcon /></span>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}
